import { isEqual } from './is-equal';

export function getUpdatedFields<C>(updates: Partial<C>, original: C, ignoreFields: string[] = []): [string, any][] {
  return Object.entries(updates).filter(([objKey, value]) => !ignoreFields.includes(objKey) && !isEqual(original[objKey], value));
}

export function hasBeenUpdated<C>(updates: Partial<C>, original: C, ignoreFields: string[] = []): boolean {
  return getUpdatedFields(updates, original, ignoreFields).length !== 0;
}
